// Utils
import useVisible from '../../hooks/useVisibile';

// Context
import { HelpSupport } from './HelpSupport';

// Components
import { Icon } from '../../common/components';

// Utils
import { HelpQuestion } from '../icons';

type HeaderHelpSupportMobileProps = {};

export const HeaderHelpSupportMobile = (props: HeaderHelpSupportMobileProps) => {
  const { ref, isComponentVisible, setIsComponentVisible } = useVisible(false);

  const handleShow = (event: any) => {
    event.preventDefault();
    setIsComponentVisible(!isComponentVisible);
  };

  return (
    <div ref={ref} className={isComponentVisible ? 'icon-circle-query-mobile-open' : 'icon-circle-query-mobile'}>
      <a href='/' onClick={handleShow} className='col-auto p-3 icon-help-mobile'>
        <Icon className={isComponentVisible ? 'active' : ''} size={'30px'} icon={HelpQuestion} />
      </a>

      <HelpSupport
        isComponentVisible={isComponentVisible}
        handleClose={() => setIsComponentVisible(false)}
      ></HelpSupport>
    </div>
  );
};
